import { Component, Input } from '@angular/core';

import { BaseDirective } from '../../globals/base.directive';
import { ApplicationIcon } from '../../utilities/types.interfaces';

@Component({
    selector: 'app-icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss']
})
export class IconComponent extends BaseDirective {
    @Input() public icon: ApplicationIcon;
}
